var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyHoleUnlocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3.71 6.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fef55f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "variables"
  }, /*#__PURE__*/React.createElement("g", {
    id: "portal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "keyicons_-open",
    "data-name": "keyicons -open"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.19,6.66l1-3.42a1.62,1.62,0,1,1,1.32,0l1,3.4H.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.71,6.8H0L1,3.31A1.77,1.77,0,1,1,3.65,1.77a1.75,1.75,0,0,1-1,1.57ZM.38,6.52h3l-1-3.34.12-.05A1.49,1.49,0,1,0,.4,1.77a1.51,1.51,0,0,0,.86,1.35l.11,0Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyHoleUnlocked);
export default __webpack_public_path__ + "static/media/key-hole-unlocked.4661875c.svg";
export { ForwardRef as ReactComponent };